import { render, staticRenderFns } from "./workout-detail.vue?vue&type=template&id=f7c6caf4&"
import script from "./workout-detail.vue?vue&type=script&lang=js&"
export * from "./workout-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports